import ReactDOM from "react-dom/client";
import { registerSW } from "virtual:pwa-register";
import "./assets/css/app.css";
import AppContent from "./AppContent";
import AppProviders from "./AppProviders";
import { initWebsiteTheme } from "./helpers/theme";
import * as Sentry from "@sentry/react";

initWebsiteTheme();

registerSW({ immediate: true });

const removeAppLoader = () => {
  const loader = document.getElementById("app-loader");
  if (loader) {
    loader.remove();
  }
};

if (process.env.REACT_APP_ENV == "Production") {
  try {
    Sentry.init({
      dsn: "https://cb22915750c43e879a49b8beda8be621@o4511417102958592.ingest.us.sentry.io/4511670103179264",
      integrations: [Sentry.browserTracingIntegration()],
      // Performance Monitoring
      tracesSampleRate: 1.0, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: [
        "",
        /^https:\/\/yourserver\.io\/api/,
      ],
    });
  } catch (error) {
    console.log("Sentry: ", error);
  }
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <AppProviders>
    <AppContent />
  </AppProviders>
);

removeAppLoader();
